/**
 * Design-direction generation contract. The agent sends intent only (page type +
 * exemplar picks); the server assembles the prompt from the saved brand and
 * the corpus description verbatim, so descriptions can never be
 * trimmed or mean-reverted by the model in between.
 */
import { z } from "zod";

export const designDirectionRequestSchema = z
  .object({
    pageType: z
      .string()
      .describe("Corpus page type of the exemplars, e.g. home-landing."),
    exemplarIds: z
      .array(z.string())
      .length(3)
      .describe(
        "Three exemplar slugs from find-design-inspiration, each from a different aestheticFamily.",
      ),
    // Receipts mark fallback-sourced facts as agent-supplied.
    brandFallback: z
      .object({ name: z.string(), sells: z.string() })
      .nullish()
      .describe(
        "Brand name and what they sell, from the user's words or get-branding. Always pass it; saved brand facts take priority.",
      ),
  })
  .describe("DesignDirectionRequest");

export const designDirectionSchema = z
  .object({
    exemplarId: z.string(),
    family: z.string(),
    jobId: z.string(),
    // Hash of the exact prompt sent — the auditable receipt.
    promptSha: z.string(),
  })
  .describe("DesignDirection");

export const designDirectionSetSchema = z
  .object({
    directions: z.array(designDirectionSchema).length(3),
    // Which project-context fields entered the preamble — every claim cites its source.
    factsUsed: z.array(z.object({ field: z.string(), value: z.string() })),
    model: z.string(),
  })
  .describe("DesignDirectionSet");
